import CoreUtils from '../../common/utils/CoreUtils';
import StringUtils from '../../common/utils/StringUtils';

import ConfigurationApi from '../../api-services/ConfigurationApi';

export default class CounterpartiesSaveHelper {
  static async commitCounterpartyChanges(counterpartyObjectList, onOperationComplete) {
    var results = {
      successes: 0,
      failures: 0
    };

    var counterparties = Array.from(counterpartyObjectList.dataObjects);

    for (var index = 0; index < counterparties.length; index++) {
      var counterparty = counterparties[index];

      if (counterparty.isDeleted) {
        await CounterpartiesSaveHelper.commitCounterpartyLogoChanges(counterparty.counterpartyLogo, results);
        await CounterpartiesSaveHelper.commitContractChanges(counterparty.contracts, results);

        var deleteResult = await ConfigurationApi.deleteCounterparty(counterparty.guid);
        if (deleteResult.ok) {
          counterpartyObjectList.removeDataObject(counterparty, true);
          results.successes += 1;
        } else {
          counterparty.setUpdateErrorMessage(await deleteResult.text());
          results.failures += 1;
        }
      } else {
        if (counterparty.isNew) {
          var postResult = await ConfigurationApi.postCounterparty(counterparty.getDtoObject());
          if (postResult.ok) {
            counterparty.commitUpdatedValues(await postResult.json());
            counterpartyObjectList.ensureDataObjectPermanent(counterparty);
            results.successes += 1;
          } else {
            counterparty.setUpdateErrorMessage(await postResult.text());
            results.failures += 1;
          }
        } else if (counterparty.isModified) {
          var putResult = await ConfigurationApi.putCounterparty(counterparty.getDtoObject());
          if (putResult.ok) {
            counterparty.commitUpdatedValues(await putResult.json());
            results.successes += 1;
          } else {
            counterparty.setUpdateErrorMessage(await putResult.text());
            results.failures += 1;
          }
        }

        await CounterpartiesSaveHelper.commitCounterpartyLogoChanges(counterparty.counterpartyLogo, results);
        await CounterpartiesSaveHelper.commitContractChanges(counterparty.contracts, results);
      }
    }

    if (CoreUtils.isDefinedAndNotNull(onOperationComplete))
      onOperationComplete(results);
  }

  static async commitCounterpartyLogoChanges(counterpartyLogo, results) {
    if (CoreUtils.isUndefinedOrNull(counterpartyLogo))
      return;

    if (!counterpartyLogo.isModified)
      return;

    var wasEmpty = !StringUtils.isNonEmptyString(counterpartyLogo.getOriginalValue('imageDataUri'));
    var isEmpty = !StringUtils.isNonEmptyString(counterpartyLogo.imageDataUri);

    if (!wasEmpty && isEmpty) {
      var deleteResult = await ConfigurationApi.deleteCounterpartyLogo(counterpartyLogo.guid);
      if (deleteResult.ok) {
        results.successes += 1;
      } else {
        counterpartyLogo.setUpdateErrorMessage(await deleteResult.text());
        results.failures += 1;
      }
    } else if (wasEmpty && !isEmpty) {
      var postResult = await ConfigurationApi.postCounterpartyLogo(counterpartyLogo.getDtoObject());
      if (postResult.ok) {
        counterpartyLogo.commitUpdatedValues(await postResult.json());
        results.successes += 1;
      } else {
        counterpartyLogo.setUpdateErrorMessage(await postResult.text());
        results.failures += 1;
      }
    } else if (!wasEmpty && !isEmpty) {
      var putResult = await ConfigurationApi.putCounterpartyLogo(counterpartyLogo.getDtoObject());
      if (putResult.ok) {
        counterpartyLogo.commitUpdatedValues(await putResult.json());
        results.successes += 1;
      } else {
        counterpartyLogo.setUpdateErrorMessage(await putResult.text());
        results.failures += 1;
      }
    }

    counterpartyLogo.commitUpdatedValues();
  }

  static async commitContractChanges(contractsObjectList, results) {
    if (CoreUtils.isUndefinedOrNull(contractsObjectList))
      return;

    var contracts = Array.from(contractsObjectList.dataObjects);

    for (var index = 0; index < contracts.length; index++) {
      var contract = contracts[index];

      if (contract.isDeleted) {
        var deleteResult = await ConfigurationApi.deleteContract(contract.guid);
        if (deleteResult.ok) {
          contractsObjectList.removeDataObject(contract, true);
          results.successes += 1;
        } else {
          contract.setUpdateErrorMessage(await deleteResult.text());
          results.failures += 1;
        }
      } else if (contract.isNew) {
        var postResult = await ConfigurationApi.postContract(contract.getDtoObject());
        if (postResult.ok) {
          contract.commitUpdatedValues(await postResult.json());
          contractsObjectList.ensureDataObjectPermanent(contract);
          results.successes += 1;
        } else {
          contract.setUpdateErrorMessage(await postResult.text());
          results.failures += 1;
        }
      } else if (contract.isModified) {
        var putResult = await ConfigurationApi.putContract(contract.getDtoObject());
        if (putResult.ok) {
          contract.commitUpdatedValues(await putResult.json());
          results.successes += 1;
        } else {
          contract.setUpdateErrorMessage(await putResult.text());
          results.failures += 1;
        }
      }
    }
  }
}